import { Flex } from "../flex";
import styles from "./SidebarNavLogo.module.scss";

export const SidebarNavLogo = ({
  productName,
  version,
  brandmarkSrc,
}: {
  productName: string;
  version: string;
  brandmarkSrc: string;
}) => {
  return (
    <Flex direction="column" className={styles["comp"]}>
      <Flex align="center" gap={10}>
        <div className={styles["comp__brandmark"]}>
          <img src={brandmarkSrc} alt="" />
        </div>
        <Flex direction="column">
          <div className={styles["comp__title"]}>{productName}</div>
          <div className={styles["comp__version"]}>{version}</div>
        </Flex>
      </Flex>
      <div className={styles["comp__separator"]} />
    </Flex>
  );
};
